module.exports = __webpack_public_path__ + "img/bs_silo_2.25b77764.png";